import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {
  Error,
  ErrorEstandar
} from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import {
  PersonasFisica,
  RPEBackPersonaFisica,
  RPEPersonaFisica
} from './entity-personas-fisica.model';
import { Rol } from '../../roles/entity-roles/roles.model';
import { EntidadesProductiva } from '../entity-entidad-productiva/entity-entidades-productiva.model';

// LOAD
export const entityPersonasFisicaLoadRequest = createAction(
  '[ENTITYPERSONASFISICA] Load Request'
);

export const entityPersonasFisicaLoadFailure = createAction(
  '[ENTITYPERSONASFISICA] Load Failure',
  props<{ error: ErrorEstandar }>()
);

export const entityPersonasFisicaLoadSuccess = createAction(
  '[ENTITYPERSONASFISICA] Load Success',
  props<{ items: PersonasFisica[] }>()
);

// ADD
export const entityPersonasFisicaAddRequest = createAction(
  '[ENTITYPERSONASFISICA] Add Request',
  props<{ item: RPEPersonaFisica }>()
);

export const entityPersonasFisicaAddFailure = createAction(
  '[ENTITYPERSONASFISICA] Add Failure',
  props<{ error: ErrorEstandar }>()
);

export const entityPersonasFisicaAddSuccess = createAction(
  '[ENTITYPERSONASFISICA] Add Success',
  props<{ item: RPEBackPersonaFisica }>()
);

// CHANGE
export const entityPersonasFisicaChangeRequest = createAction(
  '[ENTITYPERSONASFISICA] Change Request',
  props<{ item: RPEPersonaFisica }>()
);

export const entityPersonasFisicaChangeFailure = createAction(
  '[ENTITYPERSONASFISICA] Change Failure',
  props<{ error: ErrorEstandar }>()
);

export const entityPersonasFisicaChangeSuccess = createAction(
  '[ENTITYPERSONASFISICA] Change Success',
  props<{
    item: {
      persona: PersonasFisica;
      rol: Rol;
      entidadProductiva: EntidadesProductiva;
    };
  }>()
);

// DELETE
export const entityPersonasFisicaDeleteRequest = createAction(
  '[ENTITYPERSONASFISICA] Delete Request',
  props<{ item: PersonasFisica }>()
);

export const entityPersonasFisicaDeleteFailure = createAction(
  '[ENTITYPERSONASFISICA] Delete Failure',
  props<{ error: ErrorEstandar }>()
);

export const entityPersonasFisicaDeleteSuccess = createAction(
  '[ENTITYPERSONASFISICA] Delete Success',
  props<{ item: PersonasFisica }>()
);
